import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-home-cta-section",
  templateUrl: "./home-cta-section.component.html",
  styleUrls: ["./home-cta-section.component.scss"],
})
export class HomeCtaSectionComponent {
  constructor(private router: Router) {}

  openServices(): void {
    (document.activeElement as HTMLElement | null)?.blur();
    this.router.navigate(["/particulier/services"]);
  }
}
